import _ from 'lodash';
import { formatNumber } from '../../Helpers';

const forecastingDashboardAnalysisConfig = {
	initialState: {
		fields: {
			amountCaption: [
				{
					caption: 'Production Cost',
					amount: 'N/A',
				},
				{
					caption: 'Inv Consumed',
					amount: 'N/A',
				},
				{
					caption: 'Production Loss',
					amount: 'N/A',
				},
				{
					caption: 'Production Loss %',
					amount: 'N/A',
				},
				{
					caption: 'Wastage',
					amount: 'N/A',
				},
				{
					caption: 'Wastage %',
					amount: 'N/A',
				},
			],
		},
	},
	serializer: (state, data) => {
		return _.update(_.cloneDeep(state), 'fields', () => {
			const newState = {
				amountCaption: [
					...Object.keys(data).map((current) => {
						let amount = data[current]?.value;
						let percentage = null;
						if ('percentageValue' in data?.[current]) {
							percentage = data?.[current]?.percentageValue;
						}
						if (data?.[current]?.type === 'currency') {
							amount = `\u20B9${formatNumber(
								'IN',
								data[current]?.value
							)}`;
						}
						return {
							caption: data[current].label,
							amount,
							color: data?.[current]?.color,
							percentageValue: percentage
								? `${percentage} %`
								: null,
						};
					}),
				],
			};
			return newState;
		});
	},
};
export default forecastingDashboardAnalysisConfig;
